import React from 'react';
import { Link } from 'react-router-dom';

/**
 * AIDisclaimer - Vises før AI-generering og over generert resultat
 * 
 * @param {string} variant - 'before' (før generering) eller 'after' (over resultat)
 * @param {boolean} compact - Kompakt versjon for mindre plass
 */
function AIDisclaimer({ variant = 'before', compact = false }) {
  if (variant === 'before') {
    return (
      <div className={`bg-amber-50 border border-amber-200 rounded-lg ${compact ? 'p-3' : 'p-4'}`} data-testid="ai-disclaimer-before">
        <div className="flex items-start gap-3">
          <div className={`flex-shrink-0 ${compact ? 'w-8 h-8' : 'w-10 h-10'} bg-amber-100 rounded-full flex items-center justify-center`}>
            <svg className={`${compact ? 'w-4 h-4' : 'w-5 h-5'} text-amber-600`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div className="flex-1">
            <h4 className={`font-semibold text-amber-800 ${compact ? 'text-sm' : 'text-base'}`}>
              Viktig før du genererer
            </h4>
            <p className={`text-amber-700 mt-1 ${compact ? 'text-xs' : 'text-sm'}`}>
              <strong>Systemklar er et støtteverktøy og garanterer ikke etterlevelse av lover eller forskrifter.</strong>
              {' '}Du er fullt ansvarlig for å gjennomgå, tilpasse og validere alt innhold før det tas i bruk.
            </p>
            <Link 
              to="/disclaimer" 
              className={`inline-block mt-2 text-amber-600 hover:text-amber-700 font-medium ${compact ? 'text-xs' : 'text-sm'}`}
            >
              Les mer om ditt ansvar →
            </Link>
          </div>
        </div>
      </div>
    );
  }

  // variant === 'after' - Vises over generert resultat
  return (
    <div className={`bg-blue-50 border border-blue-200 rounded-lg ${compact ? 'p-3' : 'p-4'}`} data-testid="ai-disclaimer-after">
      <div className="flex items-start gap-3">
        <div className={`flex-shrink-0 ${compact ? 'w-8 h-8' : 'w-10 h-10'} bg-blue-100 rounded-full flex items-center justify-center`}>
          <svg className={`${compact ? 'w-4 h-4' : 'w-5 h-5'} text-blue-600`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
          </svg>
        </div>
        <div className="flex-1">
          <h4 className={`font-semibold text-blue-800 ${compact ? 'text-sm' : 'text-base'}`}>
            AI-generert innhold – må gjennomgås
          </h4>
          <p className={`text-blue-700 mt-1 ${compact ? 'text-xs' : 'text-sm'}`}>
            Dette innholdet er generert av kunstig intelligens og er kun et <strong>forslag</strong>. 
            <strong> Systemklar er et støtteverktøy og garanterer ikke etterlevelse av lover eller forskrifter.</strong>
            {' '}Du er fullt ansvarlig for å gjennomgå, tilpasse og validere innholdet før bruk.
          </p>
        </div>
      </div>
    </div>
  );
}

/**
 * AIDisclaimerInline - Kompakt inline-versjon for bruk i modaler etc.
 */
export function AIDisclaimerInline() {
  return (
    <p className="text-xs text-amber-600 bg-amber-50 px-3 py-2 rounded flex items-center gap-2" data-testid="ai-disclaimer-inline">
      <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
      <span>
        AI-generert utkast – må gjennomgås og tilpasses før bruk
      </span>
    </p>
  );
}

export default AIDisclaimer;
